export let ColumnWidth = /*#__PURE__*/function (ColumnWidth) {
  ColumnWidth["ONE"] = "1";
  ColumnWidth["TWO"] = "2";
  ColumnWidth["THREE"] = "3";
  ColumnWidth["FOUR"] = "4";
  ColumnWidth["FIVE"] = "5";
  ColumnWidth["SIX"] = "6";
  ColumnWidth["SEVEN"] = "7";
  ColumnWidth["EIGHT"] = "8";
  ColumnWidth["NINE"] = "9";
  ColumnWidth["TEN"] = "10";
  ColumnWidth["ELEVEN"] = "11";
  ColumnWidth["TWELVE"] = "12";
  return ColumnWidth;
}({});
export let Padding = /*#__PURE__*/function (Padding) {
  Padding["ZERO"] = "00";
  Padding["ZERO_FIVE"] = "05";
  Padding["ONE"] = "10";
  Padding["ONE_FIVE"] = "15";
  Padding["TWO"] = "20";
  Padding["TWO_FIVE"] = "25";
  Padding["THREE"] = "30";
  Padding["THREE_FIVE"] = "35";
  Padding["FOUR"] = "40";
  Padding["FOUR_FIVE"] = "45";
  Padding["FIVE"] = "50";
  return Padding;
}({});
export let FlexAlignmentX = /*#__PURE__*/function (FlexAlignmentX) {
  FlexAlignmentX["INHERIT"] = "inherit";
  FlexAlignmentX["START"] = "start";
  FlexAlignmentX["CENTER"] = "center";
  FlexAlignmentX["END"] = "end";
  return FlexAlignmentX;
}({});
export let FlexAlignmentY = /*#__PURE__*/function (FlexAlignmentY) {
  FlexAlignmentY["INHERIT"] = "inherit";
  FlexAlignmentY["TOP"] = "top";
  FlexAlignmentY["MIDDLE"] = "middle";
  FlexAlignmentY["BOTTOM"] = "bottom";
  return FlexAlignmentY;
}({});